export const INFO_ICON = 0x000024d8;
export const CLIPBOARD_ICON = 0x00002398;
export const ENVELOP_ICON = 0x00002709;
